<mat-dialog-content>
  <span class="hw-text-align-center hw-display-block" [innerHTML]="data.question | safeHtml"></span>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center;margin-bottom:1rem">
  <button mat-raised-button mdc-button--raised mat-mdc-raised-button mat-accent color="accent" (click)="no()" cdkFocusInitial>{{data.noButtonText}}</button>
  <button mat-raised-button color="primary" (click)="yes()" class="custom-next-button hw-margin-left-20px">{{data.yesButtonText}}</button>
</mat-dialog-actions>
